import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { BellLiner24 } from 'seagull/icons';
import { useEventReporter } from '~/event-reporter';
import { selectors } from '~/store/state-selectors';
import { useStore, useStoreActions } from '~/store/store-context';
import styles from './InAppNotificationsButton.module.scss';
export function InAppNotificationsButton() {
    const { setInAppNotificationsDrawerOpen, logBI } = useStoreActions();
    const showNotificationPimple = useStore((state)=>state.showNotificationPimple);
    const inAppNotificationsDrawerOpen = useStore((state)=>state.inAppNotificationsDrawerOpen);
    const email = useStore(selectors.user.email);
    const { reportToHeap } = useEventReporter();
    const triggerIcon = /*#__PURE__*/ _jsxs("div", {
        className: cn(styles.iconContainer, {
            [styles.active]: inAppNotificationsDrawerOpen
        }),
        children: [
            /*#__PURE__*/ _jsx(BellLiner24, {}),
            showNotificationPimple && /*#__PURE__*/ _jsx("div", {
                className: styles.pimple,
                "data-testid": "home-sidebar-notification-center-pimple"
            })
        ]
    });
    const handleClick = ()=>{
        logBI(15000);
        reportToHeap('sidebar', 'click', 'vendor-clicked-notifications-btn', {
            email
        });
        setInAppNotificationsDrawerOpen(true);
    };
    return /*#__PURE__*/ _jsx("div", {
        role: "button",
        className: cn(styles.root, {
            [styles.active]: inAppNotificationsDrawerOpen
        }),
        "data-testid": "home-sidebar-notification-center",
        onClick: handleClick,
        children: triggerIcon
    });
}
